// src/components/LoadingIndicator.js

import React from "react";
import { Box, CircularProgress } from "@mui/material";

function LoadingIndicator() {
  return React.createElement(
    Box,
    { display: "flex", justifyContent: "center", marginTop: "40px" },
    React.createElement(CircularProgress, null)
  );
}

export default LoadingIndicator;
